module.exports = __webpack_public_path__ + "img/xj.51213908.png";